import { graphql } from "~/gql";

export const UPDATE_LAST_LOGIN_AT = graphql(/* GraphQL */ `
  mutation updateLastLoginAt {
    updateLastLoginAt {
      id
    }
  }
`);
